import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-bold text-[#7dd3fc] mb-3">{title}</h2>
    <div className="text-white/70 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0a1628] py-16 px-6" data-testid="terms-page">
      <div className="container mx-auto max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-[#7dd3fc] transition-colors mb-8" data-testid="terms-back-link">
          <ArrowLeft size={18} />
          <span>Voltar ao site</span>
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Termos de <span className="text-[#7dd3fc]">Uso</span>
          </h1>
          <p className="text-white/40 mb-12">Última atualização: Janeiro de 2025</p>

          <Section title="1. Aceitação dos Termos">
            <p>
              Ao acessar e utilizar o site da Império Ice Ltda., você concorda com estes Termos de Uso.
              Caso não concorde com qualquer parte destes termos, recomendamos que não utilize nossos serviços.
            </p>
          </Section>

          <Section title="2. Produtos e Serviços">
            <p>
              A Império Ice Ltda. produz e comercializa gelos saborizados e gelo em sacos. As informações
              sobre produtos, preços e disponibilidade estão sujeitas a alterações sem aviso prévio.
            </p>
          </Section>

          <Section title="3. Pedidos e Orçamentos">
            <p>
              Os orçamentos solicitados através do site ou WhatsApp não constituem contrato de venda.
              Todos os pedidos estão sujeitos à confirmação de disponibilidade e condições comerciais.
            </p>
          </Section>

          <Section title="4. Propriedade Intelectual">
            <p>
              Todo o conteúdo deste site, incluindo textos, imagens, logotipos e marca, é de propriedade
              da Império Ice Ltda. e está protegido pelas leis de propriedade intelectual.
            </p>
          </Section>

          <Section title="5. Limitação de Responsabilidade">
            <p>
              A Império Ice Ltda. não se responsabiliza por danos decorrentes do uso indevido dos produtos
              ou por informações desatualizadas apresentadas neste site.
            </p>
          </Section>

          <Section title="6. Contato">
            <p>
              Para dúvidas sobre estes Termos de Uso, entre em contato através do e-mail{' '}
              <a href="mailto:comercial@imperioice.com.br" className="text-[#7dd3fc] hover:underline">
                comercial@imperioice.com.br
              </a>.
            </p>
          </Section>
        </motion.div>
      </div>
    </div>
  );
}
